import React from 'react'

const VerticalCardBodyBottom: React.FC = props => {
    return <>{props.children}</>
}

export default VerticalCardBodyBottom
